import { Component } from '@theme/component';

/**
 * Header actions component that manages cart notifications.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} liveRegion - The live region for cart announcements.
 *
 * @extends {Component<Refs>}
 */
class HeaderActions extends Component {
  requiredRefs = ['liveRegion'];

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('cart-icon:update', this.#onCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('cart-icon:update', this.#onCartUpdate);
  }

  /** @param {Event} event */
  openCart(event) {
    event.preventDefault();

    if (typeof window.Rebuy?.SmartCart?.show === 'function') {
      window.Rebuy.SmartCart.show();
    } else if (this.dataset.cartUrl) {
      window.location.assign(this.dataset.cartUrl);
    }
  }

  /**
   * Handles cart update events and announces the new count to screen readers.
   * @param {CustomEvent<{ itemCount: number }>} event
   */
  #onCartUpdate = (event) => {
    const cartCount = event.detail.itemCount;

    this.refs.liveRegion.textContent = `${Theme.translations.cart_count}: ${cartCount}`;
  };
}

if (!customElements.get('header-actions')) {
  customElements.define('header-actions', HeaderActions);
}
